<template>
  <div class="inner-box">
    <el-form size="small">
      <div class="content-name">
        <h2 class="dp-ib">스케줄관리</h2>
        <el-form-item label-width="0px" style="float: right;">
          <el-button type="primary" icon="el-icon-search" @click="goOpen">{{ this.$i18n.messages[this.$store.state.locale].search }}</el-button>
        </el-form-item>
      </div>
    </el-form>
    <!-- 검색조건 영역 -->
    <div class="search-form">
      <el-form size="mini" label-width="80px">
        <el-row style="margin-bottom: 0px;">
          <el-col :span="8">
            <el-form-item label="AS기사">
              <el-select v-model="form.userId">
                <el-option value='' label="선택">선택</el-option>
                <el-option
                      v-for="item in combos['agerntUser']"
                      :key="item.key"
                      :value="item.key"
                      :label="item.value">
                </el-option>
              </el-select>
            </el-form-item>
          </el-col>
          <el-col :span="16">
            <el-form-item label="기간">
              <el-row>
                <el-col :span="7">
                  <el-date-picker type="date" placeholder="시작일" v-model="form.startDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                </el-col>
                <el-col :span="1" style="text-align: center;">-</el-col>
                <el-col :span="8">
                  <el-date-picker type="date" placeholder="종료일" v-model="form.endDt" style="width: 100%;" value-format="yyyy-MM-dd"></el-date-picker>
                </el-col>
              </el-row>
            </el-form-item>
          </el-col>
        </el-row>
      </el-form>
    </div>
    <!-- 테이블 -->
    <div class="talbe-contain">
      <div class="table-sub-contain"  style="width: 100%;">
        <div class="table-area">
          <div class="table-b">
            <div class="table-header">
              <div class="table-name">
              </div>
              <div class="btn-wrap btn-type2 clearfix">
                <!--                <button class="btn-size btn-w-gray" @click="addRowd">-->
                <!--                  <span class="btn-icon">-->
                <!--                    <i class="fas fa-plus"></i>-->
                <!--                  </span>{{this.$i18n.messages[this.$store.state.locale].addRow}}-->
                <!--                </button>-->
              </div>
            </div>
            <!-- <dhx-grid ref="grid2" v-model="subData" :config="config_child" /> -->
            <ag-grid-vue
                ref="gridSub"
                style="width: 100%; height: 75vh; min-height: 25px;"
                class="ag-theme-alpine"
                rowSelection="multiple"


                :columnDefs="columnDefsSub"
                :defaultColDef="defaultColDefSub"
                :frameworkComponents="frameworkComponents"
                :rowData="subData"
                :gridOptions="gridOptionsSub"
                :suppressRowClickSelection="false"
                :statusBar="statusBar"
                @grid-ready="onReadyMain"
                @cell-clicked="onCellClicked"
            />
          </div>
        </div>

      </div> <!-- table sub contain -->
    </div> <!-- table contain -->

    <div class="table-header">
      <el-form style="display: grid; float: right;" size="small">
        <el-form-item label-width="0px">
          <el-button type="primary" icon="el-icon-document-add" @click="save">저장</el-button>
          <el-button type="info" icon="el-icon-close" @click="cancel">취소</el-button>
          <el-button type="danger" icon="el-icon-delete" v-if="selectId != ''"  @click="deleteRow">삭제</el-button>
        </el-form-item>
      </el-form>
    </div>

    <schedule-manager-info ref="ScheduleManagerInfo"  :custParam="custParam" :parentNm="parentNm"/>


  </div>


</template>

<script>
import _ from "lodash";

import CheckboxCellRenderer from '@/components/agGrid/checkbox-cell-renderer'
import common from '@/mixin/common';
import ScheduleManagerInfo from '@/components/InfoManage/ScheduleManagerInfo.vue';


/**
 * Url JOIN
 */
function _url(...args) {
  args = args.map(x =>
      String(x || "")
          .trim()
          .replace(/^\/*|\/*$/g, "")
  );
  return args.filter(x => x).join("/");
}

export default {
  mixins: [common],
  name: "group",
  components: {ScheduleManagerInfo},
  data() {
    return {
      title: "",
      deleteid: "",
      deleteList: [],
      parentNm: "",
      form: {
        asAgentId: "",
        asAgentNm: "",
        companyId: "",
        createDt: "",
        creatorId: "",
        creatorNm: "",
        dayType: "",
        deleteYn: "",
        description: "",
        no: "",
        scheduleCd: "",
        scheduleDt: "",
        scheduleId: "",
        updateDt: "",
        updatorId: "",
        updatorNm: "",
        userId: "",
        userNm: "",
        startDt: "",
        endDt: "",
      },
      defForm: {
        asAgentId: "",
        asAgentNm: "",
        companyId: "",
        createDt: "",
        creatorId: "",
        creatorNm: "",
        dayType: "",
        deleteYn: "",
        description: "",
        no: "",
        scheduleCd: "",
        scheduleDt: this.$moment().format('YYYY-MM-DD'),
        scheduleId: "",
        updateDt: "",
        updatorId: "",
        updatorNm: "",
        userId: "",
        userNm: "",
      },
      combos: {
        'dayType' : [], // 오전 / 오후
        'scheduleCd' : [],  // 미근무 사유
        'agerntUser' : [],        //AS기사
      },
      data: [],
      subData: [],
      gridOptions: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
        rowModelType: 'serverSide',
      },
      gridOptionsSub: {
        //enableColResize: true,
        //enableFilter: true,
        //animateRows: false,
        //enableSorting: true
      },
      defaultColDef: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
      },
      defaultColDefSub: {
        resizable: true,
        filter: true,
        sortable: true,
        editable: true,
        width: 240,
        flex: 1,
        //cellStyle : {'justify-content': 'center','align-items': 'center', 'display': 'flex','height': '100%'}
      },
      custParam: [],
      gridApi: null,
      columnApi: null,
      columnDefs: [],
      gridApiSub: null,
      columnApiSub: null,
      columnDefsSub: [],
      frameworkComponents: null,
      autoGroupColumnDef: null,
      rowModelType: null,
      isServerSideGroupOpenByDefault: null,
      isServerSideGroup: null,
      getServerSideGroupKey: null,
      selectId : "",
    };
  },
  methods: {
    //메인그리드 Ready
    onReadyMain(params) {
      //메인그리드 api 정의
      this.gridApi = params.api;
      this.columnApi = params.columnApi;

      this.init();

      //this.autoSizeAll(this.columnApi);
      // this.$store.commit('loading')
      // this.$http
      //     .post("/api/asAgentMng/scheduleMng/list", {
      //       companyId: this.$store.state.loginInfo.compCd,
      //       startDt: this.form.startDt,
      //       endDt: this.form.endDt,
      //       asAgentId: this.$store.state.loginInfo.asAgentId,
      //       userId: this.form.userId,
      //       sortType: '',
      //       page: 1,
      //       totalPage: 99999,
      //       totalCount: 0,
      //       curPage: 0,
      //       processTime: '',
      //     })
      //     .then(response => {
      //       this.subData = response.data
      //     }).finally(() => {
      //   this.$store.commit('finish')
      // });
    },
    autoSizeAll(columnApi) {
      const allColumnIds = [];
      columnApi.columnController.gridColumns.forEach((column) => {
        allColumnIds.push(column.getId());
      });
      columnApi.columnController.autoSizeColumns(allColumnIds, false);
    },
    //서브그리드 Ready
    onReadySub(params) {
      //서브그리드 api 정의
      this.gridApiSub = this.gridOptionsSub.api;
      this.columnApiSub = this.gridOptionsSub.columnApi;

      this.gridApiSub.sizeColumnsToFit();
    },
    //그리드컬럼 정의
    createColumnDefs() {
      const vm = this

      this.autoGroupColumnDef = {
        field: 'menu_nm',
        cellRendererParams: {
          innerRenderer: (params) => {
            return params.data.menu_nm;
          },
        },
      };
      this.rowModelType = 'serverSide';
      this.isServerSideGroupOpenByDefault = (params) => {
        // open first two levels by default
        return params.rowNode.level < 1;
      };
      this.isServerSideGroup = (dataItem) => {
        // indigroupe if node is a group
        //console.log(dataItem);
        return dataItem.group;
      };
      this.getServerSideGroupKey = (dataItem) => {
        // specify which group key to use
        return dataItem.menu_id;
      };

      this.columnDefsSub = [
        {headerName:'No', field:'scheduleId', width:400, editable:false},
        {headerName:'AS기사명', field:'userNm', width:400, editable:false},
        {headerName:'근무일자', field:'scheduleDt', width:400, editable:false ,
          valueFormatter: function(params) {
            return vm.getDateFormat(params);
          }
        },
        {headerName:'오전/오후', field:'dayType', width:400, editable:false ,
          valueFormatter: function(params) {
            return vm.chkDay(params);
          }
        },
        {headerName:'미근무 사유', field:'scheduleCd', width:400, editable:false,
          valueFormatter: function(params) {
            return vm.chkSchedule(params);
          }
        },
        {headerName:'미근무 상세 사유', field:'description', width:400, editable:false},

      ]
    },
    onCellClicked(event) {
      this.cancel();
      const voRow = this.gridApi.getSelectedRows() //선택된 Row
      this.selectId = voRow[0].scheduleId;
      this.$store.commit('loading')
      this.$http
          .post("/api/scheduleMng/detail", {
            companyId: this.$store.state.loginInfo.compCd,
            scheduleId: voRow[0].scheduleId,
            processTime : ""
          })
          .then(response => {
            if(response.data[0]){
              this.custParam = response.data[0];
            }
          }).finally(() => {
        this.$store.commit('finish')
      });
    },
    search(){

    },
    chkDay(params) {
      this.combos['dayType'].forEach(x =>{
        if(params.value === x.key) params.value = x.value;
      })
      return params.value;
    },
    chkSchedule(params) {
      this.combos['scheduleCd'].forEach(x =>{
        if(params.value === x.key) params.value = x.value;
      })
      return params.value;
    },
    getDateFormat(val) {
      if (val) {
        return val === 'null' ? '' : this.$moment(val).format('YYYY-MM-DD')
      }
    },
    goOpen() {

      this.$store.commit('loading')
      this.$http
          .post("/api/scheduleMng/list", {
            companyId: this.$store.state.loginInfo.compCd,
            startDt: this.form.startDt,
            endDt: this.form.endDt,
            asAgentId: this.$store.state.loginInfo.asAgentId,
            userId: this.isEmpty(this.form.userId) == "" ? 0 : this.form.userId,
            sortType: '',
            page: 1,
            totalPage: 99999,
            totalCount: 0,
            curPage: 0,
            processTime: '',
          })
          .then(response => {
            this.subData = response.data
          }).finally(() => {
        this.$store.commit('finish')
      });

    },
    isEmpty(value){
      if( value == "" || value == null || value == undefined || ( value != null && typeof value == "object" && !Object.keys(value).length ) ){
        return ""
      }else{
        return value
      }
    },
    save() {
      const grid = this.$refs.gridSub
      const Info = JSON.parse(JSON.stringify(this.$refs.ScheduleManagerInfo.form));

      if(Info.scheduleCd == ""){
        this.$swal({type: 'warning', text: '미근무사유를 선택해주세요.'});
        return false;
      }else
      if(Info.userId == ""){
        this.$swal({type: 'warning', text: 'AS기사명을 선택해주세요.'});
        return false;
      }

      // 비어있다면 생성 , 비어있지 않다면 수정
      if(Info.scheduleId == ""){
        //저장 시작

        this.$http
            .put('/api/scheduleMng/save',{
              companyId: this.$store.state.loginInfo.compCd,
              scheduleDt: Info.scheduleDt,
              userId: Info.userId,
              asAgentId: this.$store.state.loginInfo.asAgentId,
              scheduleCd: Info.scheduleCd,
              dayType: Info.dayType,
              description: Info.description,
              creatorId: this.$store.state.loginInfo.id,
              scheduleId: 0,
              processTime: ''
            })
            .then(response => {
              this.$swal({ type: 'success', text: '저장되었습니다.' });
              this.goOpen();
              this.cancel();
            })
            .catch(({ message }) => {
              if (message === "Request failed with status code 500") {
                this.$swal({ type: "error", text: "오류가 발생했습니다." });
              }
            });
      }else {
        //수정 시작
        this.$http
            .put('/api/scheduleMng/update', {
              companyId: this.$store.state.loginInfo.compCd,
              scheduleId: Info.scheduleId,
              scheduleDt: Info.scheduleDt,
              userId: Info.userId,
              asAgentId: this.$store.state.loginInfo.asAgentId,
              scheduleCd: Info.scheduleCd,
              dayType: Info.dayType,
              description: Info.description,
              updatorId: this.$store.state.loginInfo.id,
              processTime: ''
            })
            .then(response => {
              this.$swal({type: 'success', text: '저장되었습니다.'});
              this.goOpen();
              this.cancel();
            })
            .catch(({message}) => {
              if (message === "Request failed with status code 500") {
                this.$swal({type: "error", text: "오류가 발생했습니다."});
              }
            });
      }
    },

    deleteRow() {

      const voRow = this.gridApi.getSelectedRows() //선택된 Row

      this.$swal({
        type: 'info',
        text: `선택한 스케줄을 삭제하시겠습니까?`,
        showCancelButton: true,
        confirmButtonText: '예',
        cancelButtonText: '아니오',
      }).then((result) => {
        if (result.value) {
          this.$http
              .put('/api/scheduleMng/delete', {
                companyId: this.$store.state.loginInfo.compCd,
                scheduleId: voRow[0].scheduleId,
                updatorId: this.$store.state.loginInfo.id,
                processTime: ''
              })
              .then(response => {
                this.$swal({type: 'info', text: '삭제 완료 하였습니다.'});
                this.goOpen();
                this.cancel();
              })
              .catch(({message}) => {
                if (message === "Request failed with status code 500") {
                  this.$swal({type: "error", text: "오류가 발생했습니다."});
                }
              });
        }
      })




    },
    cancel(){
      this.$refs.ScheduleManagerInfo.form = _.clone(this.defForm);
      this.selectId = '';
    },
    async init() {
      this.$store.commit('loading');
      await this.$http.post(`/api/scheduleMng/init`)
          .then(response => {
            this.combos['agerntUser'] = response.data.agerntUser;  //AS기사
            this.combos['dayType'] = response.data.dayType;        // 오전 / 오후
            this.combos['scheduleCd'] = response.data.scheduleCd;  // 미근무 사유
          }).finally(() => {
            //this.goOpen();
            this.$store.commit('finish');
          });
    },
  },
  beforeMount() {

    this.createColumnDefs(); //그리드 컬럼정의 함수 호출

    this.frameworkComponents = {//그르드에서 사용할 외부 comp 등록
      checkboxRenderer: CheckboxCellRenderer,
    };

  },
  mounted() {
    //this.goOpen();
  },
  created() {
    this.statusBar = {
      statusPanels: [
        { statusPanel: 'agTotalRowCountComponent', align: 'right' },
      ],
    };
  },
  watch: {
    'form.areaAgent'() {
      this.init();
    },
    'form.areaAgentDetail'() {
      this.init();
    },
  }
};

</script>